import flatpickr from "flatpickr";

const dateFieldElems = document.querySelectorAll('[data-flatpickr]');

dateFieldElems.forEach((input) => {
  let minDate = input.dataset.minDate || null;
  let defaultDate = input.dataset.defaultDate || null;
  flatpickr(input, {
    allowInput: true,
    altInput: true,
    altFormat: "n/j/Y",
    dateFormat: "Y-m-d",
    minDate: minDate,
    defaultDate: defaultDate,
  });
})

